<template>
    <v-select 
       :value="`${selected_acco},${selected_unit}`" 
       v-bind:items="units"
       prepend-icon="mdi-filter-outline" 
       item-value="code" 
       item-text="description" 
       :label="`Select unit ${selected_unit}`"
       dense class="pl-3 pt-1" clearable
       @change="getSelection">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_unit: String,
        selected_park: String,
        selected_acco: String,
    },
    watch:{
        selected_park: {            
            handler(){
                this.units = []                
                this.getParkInfo()
            } 
        },
    },        
    data() {
        return {
            units: [],
        }
    },
    methods: {
        getParkInfo() {
            this.$axios
                .post("ares/json/ares/task/pp/getParkUnitv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getParkUnit"
                    },
                    getParkUnit: {
                        parkcode: this.selected_park
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        console.log(res.data.getParkUnit.info)
                        this.units = res.data.getParkUnit.info;
                    }
                })
        },
        getSelection(v){
            let found = false
            this.units.forEach(element => {
                if(element.code === v){
                    this.$emit('getSelection', [{field: 'unit', value: v.split(",")[1]},{field: 'acco', value: element.acco}, {field: 'plan', value: element.plan}])
                    found = true
                }
            });
            if(!found) this.$emit('getSelection', [])
        }
    }
}

</script>

<style>

</style>